/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable max-len */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsService, hd, IEmailRecipient, XSightHttpService } from '@nx-fe/services';
import { Observable } from 'rxjs';
import { IOutboundEmailConfiguration } from 'xsmodules/settings/components/email-settings/outbound-email-settings/outbound-email-settings.service';

export interface OutboundEmailFormat {
  activityId: number;
  recipients: IEmailRecipient[];
  body: string;
  subject: any;
}

// type IOutboundEmailConfiguration = IOutboundEmailConfiguration;
type INotificationConfig = hd.INotificationConfig;
type INotificationEmailTemplates = hd.INotificationEmailTemplates;
type IInboundEmailConfiguration = hd.IInboundEmailConfiguration;
type IReplyDelimiter = hd.IReplyDelimiter;

@Injectable()
export class EmailActivityService {
  private emailServiceUrl: string;

  constructor(private http: XSightHttpService, private appSettingsService: AppSettingsService) {
    this.emailServiceUrl = this.appSettingsService.emailServiceUrl;
  }

  getOutboundEmailConfiguration = (): Observable<IOutboundEmailConfiguration> =>
    this.http.get<IOutboundEmailConfiguration>(this.emailServiceUrl + 'config/outbound');

  getInboundEmailConfiguration = (): Observable<IInboundEmailConfiguration> =>
    this.http.get<IInboundEmailConfiguration>(this.emailServiceUrl + 'config/inbound');

  getNotificationConfig = (): Observable<INotificationConfig> =>
    this.http.get<INotificationConfig>(this.emailServiceUrl + 'config/notification');

  getNotificationEmailTemplate = (templateName?: string): Observable<INotificationEmailTemplates> =>
    this.http.get<INotificationEmailTemplates>(this.emailServiceUrl + `config/notification/templates/${templateName}`);

  getReplyDelimiter = (): Observable<IReplyDelimiter> =>
    this.http.get<IReplyDelimiter>(this.emailServiceUrl + 'replyDelimiter');

  public send = (email: OutboundEmailFormat): Observable<any> => {
    return this.http.post<OutboundEmailFormat>(this.emailServiceUrl + 'send', email);
  };

  public sendEmailFromTicket = (email: OutboundEmailFormat, groupId: number): Observable<any> => {
    return this.http.post<OutboundEmailFormat>(this.emailServiceUrl + `group/${groupId}/send`, email);
  };
}
